import styled from "styled-components";

const Container = styled.footer`
    @keyframes wobble-ver-right {
        0%,
        100% {
                transform: translateY(0) rotate(0);
                transform-origin: 50% 50%;
        }
        15% {
                transform: translateY(-5px) rotate(6deg);
        }
        30% {
                transform: translateY(5px) rotate(-6deg);
        }
        45% {
                transform: translateY(-5px) rotate(3.6deg);
        }
        60% {
                transform: translateY(5px) rotate(-2.4deg);
        }
        75% {
                transform: translateY(-1px) rotate(1.2deg);
        }
    }
    .social-links {
        display: flex;
        justify-content: space-around;
        width: 100%;
    }
    
    background: #212529;
    
    span {    
        font-family: Poppins;
        font-size: 18px;
    }
    i {
        font-size: 24px;
    }
    a {
        color: #fff;
        text-decoration: none;
        display: flex;
        align-items: center;
    }

    a: hover {
        text-decoration: underline;
        i {
            animation: wobble-ver-right 0.8s ease-in-out both;
        }
    }
    hr{
        color: #777;
        margin: 0 3rem;
    }
    .credits {
        color: #aaa;
        padding: 1rem 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        background: #212529;
    }
    .credits img {
        width: 28px;
        margin-left: 5px;
        height: 28px;
    }

    @media (min-width: 1400px) {
        height: 15vh;
        padding: 0;
    }
`;

const Footer = () => {
    return(
        <Container>
            <div className="py-5 social-links">
                <a href="https://www.instagram.com/vhs_tattoo/" target='_blank'>
                    <i className="bi bi-instagram me-2"/>
                    <span>
                        Instagram
                    </span>
                </a>
                <a href="https://wa.me/556798028761?text=Gostaria%20de%20solicitar%20um%20orçamento" target='_blank' >
                    <i className="bi bi-whatsapp me-2"/>
                    <span>
                        Whatsapp
                    </span>
                </a>
                <a href="mailto:vhsink67@gmail.com">
                    <i className="bi bi-envelope me-2"/>
                    <span>
                        E-mail
                    </span>
                </a>
            </div>
            <hr/>
            <div className="credits">
                Desenvolvido por <a href="https://www.dobraweb.com.br/" target="_blank"><img src="https://firebasestorage.googleapis.com/v0/b/portfolio-b03b9.appspot.com/o/dwhite.webp?alt=media&token=74ff2f96-55fe-424d-a4ee-ad25f89a910c"/></a>
            </div>
        </Container>
    )
}

export default Footer;